import styled from "@emotion/styled";


export const BuyerAssuranceLayout = styled.div<{ justifyCenter: boolean, theme: Theme }>`
  padding: 14px 32px 12px;
  margin: 20px 0 12px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyCenter }) => (justifyCenter ? "center" : "space-between")};
  border-top: ${({ theme }) => theme?.borders?.buyAssuranceBorder};
`;
